module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [(_vm.selected.id === 0) ? _c('intro', {
    attrs: {
      "onStart": _vm.start
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "map-wrapper"
  }, [(_vm.selected.id > 0) ? _c('gmap-map', {
    ref: "map",
    staticClass: "map",
    attrs: {
      "center": _vm.selected.position,
      "zoom": _vm.mapZoom,
      "options": _vm.mapOptions
    }
  }, _vm._l((_vm.locations), function(m, index) {
    return _c('gmap-marker', {
      key: index,
      attrs: {
        "position": m.position,
        "clickable": true,
        "icon": (m.info && _vm.icons.numbers[index]) ? _vm.icons.numbers[index] : _vm.defaultIcon
      },
      on: {
        "click": function($event) {
          _vm.markerOnClick(m)
        }
      }
    })
  })) : _vm._e(), _vm._v(" "), (_vm.streetviewEnabled) ? _c('button', {
    staticClass: "streetview-toggle",
    staticStyle: {
      "display": "none"
    },
    on: {
      "click": function($event) {
        _vm.closeStreetView()
      }
    }
  }, [_vm._v("Back to the map")]) : _vm._e(), _vm._v(" "), (_vm.streetviewEnabled) ? _c('gmap-map', {
    ref: "miniMap",
    staticClass: "mini-map",
    attrs: {
      "center": _vm.selected.position,
      "zoom": _vm.mapZoom,
      "options": _vm.mapOptions
    }
  }, _vm._l((_vm.locations), function(m, index) {
    return _c('gmap-marker', {
      key: index,
      attrs: {
        "position": m.position,
        "clickable": true,
        "icon": (m.info && _vm.icons.numbers[index]) ? _vm.icons.numbers[index] : _vm.defaultIcon
      },
      on: {
        "click": function($event) {
          _vm.markerOnClick(m)
        }
      }
    })
  })) : _vm._e()], 1), _vm._v(" "), (_vm.selected.id > 0) ? _c('div', {
    staticClass: "info"
  }, [_c('info', {
    attrs: {
      "selected": _vm.selected,
      "toggleGallery": _vm.toggleGallery,
      "toggleMarker": _vm.toggleMarkerByIndex,
      "locationsQty": _vm.locations.length
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showGallery) ? _c('h3', {
    staticClass: "expanded-title"
  }, [_vm._v(_vm._s(_vm.selected.info.title))]) : _vm._e(), _vm._v(" "), (_vm.showGallery) ? _c('div', {
    staticClass: "carousel"
  }, [_c('carousel', {
    ref: "gallery",
    attrs: {
      "navigationEnabled": true,
      "paginationEnabled": false,
      "perPage": 1
    }
  }, _vm._l((_vm.gallery), function(img, index) {
    return _c('slide', {
      key: index
    }, [_c('div', {
      staticClass: "slider-image-wrapper"
    }, [_c('img', {
      staticClass: "slider-image",
      attrs: {
        "src": img
      },
      on: {
        "click": _vm.toggleGallery
      }
    })])])
  })), _vm._v(" "), _c('div', {
    staticClass: "image-note"
  }, [_vm._v("(click on the image to close)")])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fa8a3a58"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Map.vue
// module id = 138
// module chunks = 1